import createTaxonomyLink from './createTaxonomyLink';
import uniqBy from 'lodash/uniqBy';
import createTaxonomyListFromQuery from './createTaxonomyListFromQuery';

export default (query, filterType, taxonomy) => {
	const queryTaxonomyList = createTaxonomyListFromQuery(query);
	const addedTaxonomyList = uniqBy([
		...queryTaxonomyList,
		{
			_type: filterType,
			slug: taxonomy,
		}
	], f => `${f._type}_${f.slug}`);

	return createTaxonomyLink(addedTaxonomyList);
};